import {
  getFirstAccessibleChild,
  getFirstAccessibleRoute,
} from '@/features/auth/access-control/getFirstAccessibleChild';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    const first =
      getFirstAccessibleChild('/store-information', context.perms) ?? getFirstAccessibleRoute(context.perms);

    if (!first) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/dashboard', replace: true });
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: first, replace: true });
  },
});

function RouteComponent() {
  return <div>Hello /(app)/store-information/</div>;
}
